import { render, staticRenderFns } from "./CompletedAfter.vue?vue&type=template&id=72bf3d9f&scoped=true&"
import script from "./CompletedAfter.vue?vue&type=script&lang=js&"
export * from "./CompletedAfter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf3d9f",
  null
  
)

export default component.exports